import { SectionPaper } from "@/components/Paper";
import { Select } from "@/components/Select";
import { SectionTitle } from "@/components/Title";
import { ClientDmUsageGrid } from "@/features/accountSettings/components";
import {
  useClientDmUsages,
  useClientMonthlyBudgetStatusList,
} from "@/features/accountSettings/api";
import { getUsageYearMonthText } from "@/features/accountSettings/utils";
import { Box, Divider, Typography } from "@mui/material";
import { useMemo, useState } from "react";

/**
 * 所属企業の全ユーザーのDM費用（R.E.DATA Plus 外で発生したDM関連費用）を月別に表示する。
 * 月の選択肢は企業の消費クレジットと同じく企業の月次予算状況から作る。
 */
export const ClientDmUsage: React.FC = () => {
  const [billingDate, setBillingDate] = useState<Date | undefined>(undefined);

  const monthlyBudgetStatusListResponse = useClientMonthlyBudgetStatusList();

  const billingDates: Date[] = useMemo(
    () =>
      monthlyBudgetStatusListResponse.map<Date>(
        (data) => new Date(data.billingDate)
      ),
    [monthlyBudgetStatusListResponse]
  );

  const dmUsages = useClientDmUsages(
    billingDate?.getFullYear(),
    billingDate !== undefined ? billingDate.getMonth() + 1 : undefined
  );

  const totalAmount = (dmUsages ?? []).reduce(
    (total, dmUsage) => total + dmUsage.amount,
    0
  );

  const handleChange = (value: string): void => {
    setBillingDate(billingDates.find((e) => String(e.getTime()) === value));
  };

  return (
    <SectionPaper>
      <Box sx={{ display: "flex" }}>
        <SectionTitle>企業のDM費用</SectionTitle>
        <Box sx={{ mx: "auto" }}></Box>
        <Box sx={{ display: "flex", alignItems: "center", mx: 1 }}>
          <Select
            label="月"
            isClearable={false}
            options={billingDates.map((e) => {
              return {
                label: getUsageYearMonthText(e),
                value: String(e.getTime()),
              };
            })}
            onChange={handleChange}
          ></Select>
        </Box>
      </Box>
      <Divider />
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box sx={{ mx: "auto" }}></Box>
        <SectionTitle>
          DM費用合計：{totalAmount.toLocaleString()}円
        </SectionTitle>
      </Box>
      {dmUsages !== undefined &&
        (dmUsages.length > 0 ? (
          <ClientDmUsageGrid dmUsages={dmUsages}></ClientDmUsageGrid>
        ) : (
          <Typography sx={{ m: 2 }}>該当する利用はありません</Typography>
        ))}
    </SectionPaper>
  );
};
